/**
 * Maintaining all events in the application as constants
 * for tracking mainly
 *
 * @author John Lukose <john.lukose@quikr.com>
 */

const EVENTS = {
  SNB_CONTAINER_EVENTS: {
    SORT_FILTER_CLICKED: "SORT_FILTER_CLICKED",
    SORT_FILTER_ITEM_CLICKED: "SORT_FILTER_ITEM_CLICKED",
    SORT_FILTER_CLOSED: "SORT_FILTER_CLOSED",
    FILTER_OPEN: "FILTER_OPEN",
    FILTER_CLOSE: "FILTER_CLOSE",
    FILTER_PREPARE: "FILTER_PREPARE",
    FILTER_APPLY: "FILTER_APPLY",
    FILTER_RESET: "FILTER_RESET",
    FILTER_ITEM_CLICKED: "FILTER_ITEM_CLICKED",
    FILTER_MOUNTED: "FILTER_MOUNTED",
    UPDATE_JOB_LISTINGS: "UPDATE_JOB_LISTINGS",
    UPDATE_JOB_PAGE: "UPDATE_JOB_PAGE",
    RECEVED_SIMILAR_JOBS_AJAXDATA: "RECEVED_SIMILAR_JOBS_AJAXDATA",
    UPDATE_FILTER_STATE: "UPDATE_FILTER_STATE",
    NORTHEAST_MY_CITY: "NORTHEAST_MY_CITY",
    SHOW_NORTHEAST_CITY_FILTER: "SHOW_NORTHEAST_CITY_FILTER"
  }
};
export default EVENTS;

export const JOB_EVENTS = {
  UPDATE_JOB: "UPDATE_JOB",
  UPDATE_NEW_JOB: "UPDATE_NEW_JOB",
  UPDATE_RSA_DATA: "UPDATE_RSA_DATA"
};

export const APPLY_EVENTS = {
  UPDATE_APPLY: "UPDATE_APPLY",
  TOGGLE_CALL_UNLOCK_CANDIDATE_BUY_OPTIONS:
    "TOGGLE_CALL_UNLOCK_CANDIDATE_BUY_OPTIONS",
  FORM_FIELD_CHANGE: "FORM_FIELD_CHANGE",
  WHATSAPP_NOTIFICATION: "WHATSAPP_NOTIFICATION",
  TOGGLE_SKIP_APPLY_FLAG: "TOGGLE_SKIP_APPLY_FLAG",
  TOGGLE_QUICK_APPLY_FLAG: "TOGGLE_QUICK_APPLY_FLAG",
  SET_UTM_PARAMETERS: "SET_UTM_PARAMETERS"
};

export const USER_EVENTS = {
  UPDATE_USER: "UPDATE_USER"
};

export const CONTEXT_EVENTS = {
  UPDATE_CONTEXT: "UPDATE_CONTEXT",
  SEARCH_POPUP_TOGGLE: "SEARCH_POPUP_TOGGLE",
  TOGGLE_LOADER: "TOGGLE_LOADER"
};

export const JOB_SEARCH_EVENTS = {
  UPDATE_JOB_SEARCH_LIST: "UPDATE_JOB_SEARCH_LIST",
  UPDATE_DFP_OPTIONS: "UPDATE_DFP_OPTIONS",
  EMPTY_JOB_SEARCH_LIST: "EMPTY_JOB_SEARCH_LIST",
  TOGGLE_JOB_LIST_DISPLAY: "TOGGLE_JOB_LIST_DISPLAY",
  UPDATE_JOB_SEARCH_REDUCER: "UPDATE_JOB_SEARCH_REDUCER"
};

export const CONFIG_EVENTS = {
  UPDATE_CONFIG: "UPDATE_CONFIG",
  CONFIG_UPDATED: "CONFIG_UPDATED"
};

/**
 * PS1 : Post Ad Step 1
 * PS2 : Post Ad Step 2
 * ES2 : Edit Ad Step 1
 * ES2 : Edit Ad Step 2
 *
 * JOBS_POST_AD contains all the events for post/edit ad for both step1 and step2
 */
export const JOBS_POST_AD_EVENTS = {
  FEATURE_CHANGE: "FEATURE_CHANGE",
  AD_ATTRIBUTE_CHANGE: "AD_ATTRIBUTE_CHANGE",
  UPDATE_PACK_SELECTED: "UPDATE_PACK_SELECTED"
};

export const INTEGRATIONS_EVENTS = {
  FORM_OPEN: "FORM_OPEN",
  FORM_CLOSE: "FORM_CLOSE",
  FORM_FIELD_CHANGE: "FORM_FIELD_CHANGE",
  FORM_SUBMITTED: "FORM_SUBMITTED",
  SET_FORM_TYPE: "SET_FORM_TYPE",
  CLEAR_FORM: "CLEAR_FORM",
  FORM_CHANGE: "FORM_CHANGE",
  INTEGRATION_SOURCE_CLEAR: "INTEGRATION_SOURCE_CLEAR",
  UPDATE_FORM_STATE: "UPDATE_FORM_STATE"
};

export const WINDOW_EVENTS = {
  REMOVE_ERROR_MESSAGE: "REMOVE_ERROR_MESSAGE",
  UPDATE_DATA: "UPDATE_WINDOW_DATA"
};

export const CANDIDATE_TEST_EVENTS = {
  INITIALIZE_CONTEXT: "CANDIDATE_TEST_INITIALIZE_CONTEXT",
  SHOW_NEXT_SURVEY_QUESTION: "SHOW_NEXT_SURVEY_QUESTION",
  SHOW_PREVIOUS_SURVEY_QUESTION: "SHOW_PREVIOUS_SURVEY_QUESTION",
  UPDATE_CONTEXT: "CANDIDATE_TEST_UPDATE_CONTEXT",
  CHANGE_TAB: "CANDIDATE_TEST_CHANGE_TAB",
  START_TEST: "START_TEST",
  SHOW_RESPONSE: "SHOW_RESPONSE",
  SHOW_NEXT_RESPONSE_SCREEN: "SHOW_NEXT_RESPONSE_SCREEN",
  SET_FINAL_FEEDBACK_ANSWER: "SET_FINAL_FEEDBACK_ANSWER",
  SET_REDIRECT_URL: "CANDIDATE_TEST_SET_REDIRECT_URL",
  SET_ERROR: "CANDIDATE_TEST_SET_ERROR"
};

export const PROFILE_EVENTS = {
  TOGGLE_POPUP: "PROFILE_TOGGLE_POPUP",
  SET_QUESTION: "PROFILE_SET_QUESTION",
  INITIALIZE_CONTEXT: "PROFILE_INITIALIZE_CONTEXT",
  UPDATE_CONTEXT: "PROFILE_UPDATE_CONTEXT",
  TOGGLE_ACK: "PROFILE_TOGGLE_ACK",
  FORM_SUBMITTED: "PROFILE_FORM_SUBMITTED"
};



// WEBPACK FOOTER //
// ../q-jobs/src/constants/events.js